export const useDate = () => {

    const formatDate = (date, format) => {
        const map = {
            mm: date.getMonth() + 1,
            dd: date.getDate(),
            aa: date.getFullYear().toString().slice(-2),
            aaaa: date.getFullYear()
        }

        const verifyLengthDay = map.dd.toString();
        const verifyLengthMonth = map.mm.toString();
        
        if (verifyLengthDay.length < 2 ){
            map.dd = `0${map.dd}`
        }
        
        if (verifyLengthMonth.length < 2 ){
            map.mm = `0${map.mm}`
        }

        return format.replace(/aaaa|dd|mm|aa/gi, matched => map[matched])
    }

    return {
        formatDate
    }
}